// Centralized brand assets for easy editing later.
export const BRAND = {
  name: "Musemi",
  tagline: "Shared wardrobe. Endless moments.",
  instagram: {
    handle: "@wearemusemi",
    url: "https://instagram.com/wearemusemi",
  },
  colors: {
    cream: "#F8F6F2",
    creamDeep: "#EAE5DF",
    ink: "#332622",
    inkSoft: "#7A736E",
    mauve: "#634F50",
    mauveDark: "#4A2832",
    burgundy: "#632733",
    chocolate: "#3D2B25",
    taupe: "#B5A9A1",
  },
};

export const LOGOS = {
  // Official MUSEMI logo asset — SVG (crisp, scalable)
  cream:
    "https://customer-assets.emergentagent.com/job_musemi-collective/artifacts/qreepb0t_MUSEMI%20IG%20Profile.svg",
  // Fallback / black variant
  black:
    "https://customer-assets.emergentagent.com/job_musemi-collective/artifacts/k22if29w_MUSEMI%20IG%20Profile.png",
};

export const IMAGES = {
  hero:
    "https://customer-assets.emergentagent.com/job_musemi-collective/artifacts/5g3rhv7t__%20-%202026-05-12T172423.384.jpeg",
  whatIs:
    "https://customer-assets.emergentagent.com/job_musemi-collective/artifacts/p9m0o503__%20-%202026-05-10T151031.118.jpeg",
  borrow: "https://images.pexels.com/photos/7031843/pexels-photo-7031843.jpeg",
  lend:
    "https://images.unsplash.com/photo-1768845431923-0146cf14804d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwbHV4dXJ5JTIwZmFzaGlvbiUyMGVkaXRvcmlhbHxlbnwwfHx8fDE3Nzg2MTAxOTV8MA&ixlib=rb-4.1.0&q=85",
  discover:
    "https://images.unsplash.com/photo-1642449130285-776aaf432d1c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1NzZ8MHwxfHNlYXJjaHwxfHxmYXNoaW9uJTIwbW9kZWwlMjBldmVuaW5nJTIwZHJlc3N8ZW58MHx8fHwxNzc4NjEwMjIzfDA&ixlib=rb-4.1.0&q=85",
  edits: {
    newIn:
      "https://static.prod-images.emergentagent.com/jobs/64b1dbc8-d5ce-4f48-8b79-456595ae76a7/images/42dabb0f75cb5458c6fcaa7fd051c5b67fca8a3ecbbf7b03a6aa4efa951e9b9b.png",
    wedding:
      "https://customer-assets.emergentagent.com/job_musemi-collective/artifacts/f4igd3iu_wedding-season.jpeg",
    night:
      "https://customer-assets.emergentagent.com/job_musemi-collective/artifacts/s3zvi50i_night-out.jpeg",
    euro:
      "https://customer-assets.emergentagent.com/job_musemi-collective/artifacts/dpl68bu4_EURO-SUMMMER.jpeg",
    coolGirl:
      "https://images.unsplash.com/photo-1772026251816-a6d382c67b3b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NjZ8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBoYW5kYmFnJTIwc3RpbGwlMjBsaWZlfGVufDB8fHx8MTc3ODYxMDIyNHww&ixlib=rb-4.1.0&q=85",
    perfectMatch:
      "https://static.prod-images.emergentagent.com/jobs/64b1dbc8-d5ce-4f48-8b79-456595ae76a7/images/1907a376446664ff4493c5e9eb7c27d79bae8250aefa439fc60a50d1570e9e34.png",
  },
};
